export default __webpack_public_path__ + "static/media/utivawhite.17c33e0c.svg";